<!-- pc端的顶部菜单 -->
<template>
  <div class="wrap">
    <div class="brand">
      <h3>政府采购评价系统</h3>
      <div @click="foldMenu">
        <span :class="[opening ? 'el-icon-right' : 'el-icon-back']"></span>
      </div>
    </div>
    <div class="right">
      <div class="user-info">
        <i class="el-icon-user-solid"></i>
        <span>{{ userName }}</span>
      </div>
      <div class="logout" @click="setting(true)">
        <el-tooltip content="修改密码" placement="bottom-end">
          <i class="el-icon-s-tools"></i>
        </el-tooltip>
      </div>
      <div class="logout" @click="logout">
        <el-tooltip effect="dark" content="退出" placement="bottom-end">
          <i class="el-icon-switch-button"></i>
        </el-tooltip>
      </div>
    </div>

    <setting :isShow="isShow" @closeIt="setting"/>
  </div>
</template>
<script>
import Setting from "./Setting.vue";

export default {
  components: { Setting },
  data() {
    return {
      isShow: false,
      opening: false
    };
  },
  computed: {
    userName() {
      return this.$store.state.loginInfo.userName;
    },
  },
  methods: {
    logout() {
      this.$router.replace("/login");
    },
    setting(state) {
      this.isShow = state;
    },

    foldMenu() {
      this.opening = !this.opening
      this.$bus.$emit('foldMenu')
    }
  },
};
</script>
<style lang="less" scoped>
.wrap {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .brand {
    font-size: 1.4rem;
    font-family: "宋体";
    color: var(--themeColor);
    text-shadow: 1px 1px 0 #20202027;
    display: flex;
    align-items: center;

    div{
      border: 1px solid var(--themeColor);
      padding: 0 3px;
      border-radius: 50%;
      margin-left: 1rem;
      width: 23px;
      height: 23px;
      cursor: pointer;
      opacity: .8;
      span{
        font-size: .95rem;
        transition: all .3s;
        transform: translateY(-3px);
        font-weight: bold;
      }
    }
  }

  .right {
    display: flex;
    padding-top: 5px;

    > div {
      margin-left: 2.4rem;
    }

    .user-info {
      display: flex;
      align-items: center;

      span {
        padding-left: 4px;
        font-size: .95rem;
        color: #455;
        padding-bottom: .15rem;
      }
    }

    i {
      font-size: 1.3rem;
      color: #888;
    }

    .logout {
      cursor: pointer;

      &:hover i {
        color: var(--themeColor);
      }
    }
  }
}
</style>